import { useEffect, useState } from "react";

/**
 * useHideOnModal — subscribes to the global glpflo:modal-open /
 * glpflo:modal-close window events emitted by any modal (currently
 * FitQuizModal) and returns true while a modal is open. Sticky
 * banners use this to quietly disappear when a modal owns the
 * viewport, then restore themselves when it closes.
 */
export default function useHideOnModal() {
  const [hidden, setHidden] = useState(false);
  useEffect(() => {
    const on = () => setHidden(true);
    const off = () => setHidden(false);
    window.addEventListener("glpflo:modal-open", on);
    window.addEventListener("glpflo:modal-close", off);
    return () => {
      window.removeEventListener("glpflo:modal-open", on);
      window.removeEventListener("glpflo:modal-close", off);
    };
  }, []);
  return hidden;
}
